import { DeliveryType } from '../enums';

export interface ReservationRequest {
  product_id: string;
  product_variant_id?: string;
  cart_id?: string;
  shop_session_id: string;
  delivery_method?: DeliveryType;
}
